




























import { Vue, Component } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
// 現在、NTT東日本の無線LAN付きルーターをレンタルしていますか。
export default class CurrentRentalNttWestWifiRouter extends Vue {
  public selectRadioList: { id: string; text: string, price: number }[] = [
    {
      id: 'not_rental',
      text: 'レンタルしていない',
      price: 0,
    },
    {
      id: 'ntt_east_router_rental',
      text: 'レンタルしている　',
      price: 500,
    },
  ];
  mounted() {
    const value = this.$store.getters['hikari/router']
    if (value === 'not_rental' || value === 'ntt_east_router_rental') {
      this.$store.commit(`hikari/router`, value);
    } else {
      this.$store.commit(`hikari/router`, 'not_rental');
    }
  }
}
